import { AxiosResponse } from 'axios'
import { axiosInstance } from 'axiosInstance'

import { APPLICATION_URLS } from 'config/urls'

import { IPalette, IColorPalette, IImagePalette } from '../store/types'

export const getTemplates = (
    designType: 'COLOR' | 'IMAGE' = 'COLOR',
): Promise<AxiosResponse<IPalette[]>> =>
    axiosInstance.get(`${APPLICATION_URLS.applications}/colors/${designType}`)

export const getColorsTemplates = (): Promise<AxiosResponse<IColorPalette[]>> =>
    axiosInstance.get(`${APPLICATION_URLS.applications}/colors/COLOR`)

export const getImagesTemplates = (): Promise<AxiosResponse<IImagePalette[]>> =>
    axiosInstance.get(`${APPLICATION_URLS.applications}/colors/IMAGE`)

export const getChosenPalette = ({
    appId,
}: {
    appId: string
}): Promise<AxiosResponse<IPalette>> =>
    axiosInstance.get(`${APPLICATION_URLS.applications}/${appId}/colors`)

export const editChosenPalette = ({
    appId,
    palette,
    designType = 'COLOR',
}: {
    appId: string
    palette: IPalette
    designType?: 'COLOR' | 'IMAGE'
}): Promise<AxiosResponse<IPalette>> =>
    axiosInstance.put(
        `${APPLICATION_URLS.applications}/${appId}/colors/${designType}`,
        palette,
    )
